import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { PushProvider } from '../../providers/push/push'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { UtilsProvider } from '../../providers/utils/utils'
import { NUBE_AWS } from '../../config/url.servicio';
/**
 * Generated class for the ParametrosGeneralesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-parametros-caja',
  templateUrl: 'parametros-caja.html',
  providers: [ AuthService,PushProvider,UtilsProvider ]
})
export class ParametrosCajaPage {
  CheckEscucharMesas:boolean = false
  CajaDinamica: CajaDinamica[] = []
  CantidadEnVenta: CantidadEnVenta[] = []
  DevolverLaVenta: DevolverVenta[] = []
  ProductoRapidoDesdeCaja: ProductoRapidoCaja[] = []
  BotonActivoImprimir: ValoresActivoImprimir[] = []
  CantidadImpresionCaja: CantidadImpresionesCaja[] = []
  DigitaDetalleCaja: DigitaDetalleCaja[] = []
  ClienteDesdeCaja: ClienteDesdeCaja[] = []
  DetalleReciboEnCaja: DetalleReciboEnCaja[] = []
  DetalleCambiarPrecioEnLosProductos: DetalleCambiarPrecioEnLosProductos[] = []

  cantidadImpresonesCaja: string = "1"
  activoImprimir: string = "S"
  creaProductoRapidoDesdeCaja: string = "S"
  devolverVenta: string = "S"
  digitaCantidadEnVenta: string = "S"
  manejaCajaDinamica: string = "S"
  digitaDescripcionEnCaja: string = "S"
  creaClienteDesdeCaja: string = "S"
  visualizaDetalleReciboEnCaja: string = "S"
  cambiarPrecioEnLosProductos: string = "S"
  creaVentaDesdePedidosSalon: string = "N"
  creaTurno: string = "N"
  manejaDescuentoPorPorcentaje: string = "N"
  DetallecreaVentaDesdePedidosSalon: DetallecreaVentaDesdePedidosSalon[] = []
  DetallecreaTurno: DetallecreaTurno[] = []
  DetallemanejaDescuentoPorPorcentaje: DetallemanejaDescuentoPorPorcentaje[] = []
  inputIP: string = ""
  isValidIP: boolean = true;
  constructor(public navCtrl: NavController, public navParams: NavParams,public storage:Storage,
    public auth: AuthService,
    public servicioPush:PushProvider,
    public toastControllers:ToastController,
    public mensajero: UtilsProvider,
    public utilidades:ClientesProvider) {

    this.CajaDinamica.push({nombre:"No",valor:"N"},{nombre:"Si", valor:"S"})
    this.CantidadEnVenta.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.DevolverLaVenta.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.ProductoRapidoDesdeCaja.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.BotonActivoImprimir.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.CantidadImpresionCaja.push({nombre: "1", valor: "1"},{nombre: "2", valor: "2"},{nombre: "3", valor: "3"},{nombre: "4", valor: "4"})
    this.DigitaDetalleCaja.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.ClienteDesdeCaja.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetalleReciboEnCaja.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetalleCambiarPrecioEnLosProductos.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetallecreaVentaDesdePedidosSalon.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetallecreaTurno.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})
    this.DetallemanejaDescuentoPorPorcentaje.push({nombre: "No", valor: "N"}, {nombre:"Si",valor:"S"})

    this.traerDatosIniciales()

  }


  traerDatosIniciales(){

    this.storage.get('companiasId').then((val)=>{
      if(val){
        this.servicioPush.buscarParametrosGeneralesParaMaestro(val)
        .subscribe((dataParametrosGrales)=>{
          let valuesParametrosGenerales
          if(NUBE_AWS) {
            valuesParametrosGenerales = JSON.parse(dataParametrosGrales['_body']).data[0][0]
          } else {
            valuesParametrosGenerales = dataParametrosGrales[0][0]
          }
          this.cantidadImpresonesCaja = valuesParametrosGenerales.cantidadImpresonesCaja.toString();
          this.activoImprimir = valuesParametrosGenerales.activoImprimir;
          this.creaProductoRapidoDesdeCaja = valuesParametrosGenerales.creaProductoRapidoDesdeCaja;
          this.devolverVenta = valuesParametrosGenerales.devolverVenta;
          this.digitaCantidadEnVenta = valuesParametrosGenerales.digitaCantidadEnVenta;
          this.manejaCajaDinamica =  valuesParametrosGenerales.manejaCajaDinamica;
          this.digitaDescripcionEnCaja = valuesParametrosGenerales.digitaDescripcionEnCaja;
          this.creaClienteDesdeCaja = valuesParametrosGenerales.creaClienteDesdeCaja;
          this.visualizaDetalleReciboEnCaja = valuesParametrosGenerales.visualizaDetalleReciboEnCaja;
          this.cambiarPrecioEnLosProductos = valuesParametrosGenerales.cambiarPrecioEnLosProductos;
          this.creaVentaDesdePedidosSalon = valuesParametrosGenerales.creaVentaDesdePedidosSalon;
          this.creaTurno = valuesParametrosGenerales.creaTurno;
          this.manejaDescuentoPorPorcentaje = valuesParametrosGenerales.manejaDescuentoPorPorcentaje;
        },(error)=>{
          console.log(error)
        })
      }
    })


}


  ionViewDidLoad() {
    console.log('ionViewDidLoad ParametrosGeneralesPage');
  }


  cambiarValoresTabla(){

    this.storage.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscarParametrosGenerales(val)
        .subscribe((valores)=>{
          let id = ''
          if(NUBE_AWS) {
            id = JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId
          } else {
            id = valores[0][0].parametrosGeneralesId
          }

          let data = {}
          data['name']= "dataDynamicCrud"
          data['parametrosGeneralesId']= id
          data['queHago']= "A"
          data['digitaCantidadEnVenta']= this.digitaCantidadEnVenta
          data['manejaCajaDinamica']= this.manejaCajaDinamica
          data['devolverVenta']= this.devolverVenta
          data['creaProductoRapidoDesdeCaja']= this.creaProductoRapidoDesdeCaja
          data['activoImprimir']= this.activoImprimir
          data['cantidadImpresonesCaja']= this.cantidadImpresonesCaja
          data['digitaDescripcionEnCaja']= this.digitaDescripcionEnCaja
          data['creaClienteDesdeCaja'] = this.creaClienteDesdeCaja
          data['visualizaDetalleReciboEnCaja'] = this.visualizaDetalleReciboEnCaja
          data['cambiarPrecioEnLosProductos'] = this.cambiarPrecioEnLosProductos
          data['creaVentaDesdePedidosSalon'] = this.creaVentaDesdePedidosSalon
          data['creaTurno'] = this.creaTurno
          data['manejaDescuentoPorPorcentaje'] = this.manejaDescuentoPorPorcentaje,
          data['ip'] = this.inputIP
          data['nombreTabla']= "parametrosGenerales"

          this.servicioPush.actualizarParametrosGenerales(data)
          .subscribe((nuevoValor)=>{
            this.mensajero.mensajeMuestro('Parametros Caja','Registro actualizado con éxito','success')
          },(error)=>{
            console.log(error)
          })
        },(error)=>{
          console.log(error)
        })

      }
    })

  }

  valoresSelectCajaDinamica(data:string){
    this.manejaCajaDinamica = data
  }

  valoresDigitaCantidadEnVenta(data:string){
    this.digitaCantidadEnVenta = data
  }

  valoresActivoImprimir(data:string){
    this.activoImprimir = data

  }

  valoresCreaProductoRapidoDesdeCaja(data:string){
    this.creaProductoRapidoDesdeCaja = data
  }

  valoresDigitaDevolverVenta(data:string){
    this.devolverVenta = data
  }

  valoresCantidadImprimirCaja(data:string){
    this.cantidadImpresonesCaja = data
  }

  valorDigitaDetalleEnCaja(data: string){
    this.digitaDescripcionEnCaja = data
  }

  valoresCreaClienteDesdeCaja(data: string){
    this.creaClienteDesdeCaja = data
  }

  valoresVisualizaDetalleReciboEnCaja(data: string){
    this.visualizaDetalleReciboEnCaja = data
  }

  valorescambiarPrecioEnLosProductos(data: string){
    this.cambiarPrecioEnLosProductos = data
  }

  valorescambiarCreaVentaDesdePedidosSalon(data: string){
    this.creaVentaDesdePedidosSalon = data
  }

  valorescambiarcreaTurno(data: string){
    this.creaTurno = data
  }

  valorescambiarmanejaDescuentoPorPorcentaje(data: string){
    this.manejaDescuentoPorPorcentaje = data
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }
  validateIP() {
    const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    this.isValidIP = ipPattern.test(this.inputIP);
    if(!this.isValidIP) {
      this.mensajeToast('Ip no valida')
      this.inputIP = ''
    }
  }
}

class CajaDinamica {
  public nombre:string;
  public valor:string;
}

class CantidadEnVenta {
  public nombre:string;
  public valor:string;
}

class DevolverVenta {
  public nombre:string;
  public valor:string;
}

class ProductoRapidoCaja{
  public nombre:string;
  public valor:string;
}

class ValoresActivoImprimir{
  public nombre:string;
  public valor:string;
}

class CantidadImpresionesCaja{
  public nombre:string;
  public valor:string;
}

class DigitaDetalleCaja{
  public nombre: string;
  public valor: string;
}

class ClienteDesdeCaja{
  public nombre: string;
  public valor: string;
}

class DetalleReciboEnCaja{
  public nombre: string;
  public valor: string
}

class DetalleCambiarPrecioEnLosProductos {
  public nombre: string;
  public valor: string
}

class DetallecreaVentaDesdePedidosSalon {
  public nombre: string;
  public valor: string
}

class DetallecreaTurno {
  public nombre: string;
  public valor: string
}

class DetallemanejaDescuentoPorPorcentaje {
  public nombre: string;
  public valor: string
}




// WEBPACK FOOTER //
// ./src/pages/parametros-caja/parametros-caja.ts